import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useGetInvoicelessCustomer } from "../../hooks/useCrm";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import Loading from "../Loadings/LoadingTable";
import { Table } from "../Table/Table";
import { InvoicelessCustomersWrapper } from "./InvoicelessCustomersStyle";

export const InvoicelessCustomers = () => {
  const { data, isLoading } = useGetInvoicelessCustomer();
  const [Search, setSearch] = useState("");

  const headerTitle = [
    "ردیف",
    "نام و نام خانوادگی",
    "نام و نام خانوادگی مسئول",
    "تاریخ ثبت نام",
    "تاریخ آخرین خرید",
  ];
  let itemsStoreLength = 0;
  const itemsStore = data?.data?.File?.filter((user) => {
    const name = user.split("x:");

    if (Search === "") {
      return user;
    } else if (name[2].includes(Search)) {
      return user;
    } else if (name[3].includes(Search)) {
      return user;
    }
  }).map((item, index) => {
    const name = item.split("x:");
    if (
      name[3] !== "مشتریان خانگی" &&
      name[3] !== "پرونده بچگانه" &&
      name[3] !== "پرونده لباس زیر"
    ) {
      itemsStoreLength++;
      return (
        <tr key={index}>
          <td>
            <span className="text-muted fw-bold d-block fs-7">
              {itemsStoreLength}
            </span>
          </td>
          <td>
            <Link to={`/dashboard/crm/customer-file/${name[1]}`}>
              <span className="text-muted fw-bold d-block fs-7">{name[2]}</span>
            </Link>
          </td>
          <td>
            <span className="text-muted fw-bold d-block fs-7">{name[3]}</span>
          </td>
          <td>
            <span className="text-muted fw-bold d-block fs-7">
              {MiladiToShamsi(name[4])}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold d-block fs-7">
              {name[5] ? MiladiToShamsi(name[5]) : "ندارد"}
            </span>
          </td>
        </tr>
      );
    }
  });

  let itemsHomeLength = 0;
  const itemsHome = data?.data?.File?.filter((user) => {
    const name = user.split("x:");
    if (Search === "") {
      return user;
    } else if (name[2].includes(Search)) {
      return user;
    } else if (name[3].includes(Search)) {
      return user;
    }
  }).map((item, index) => {
    const name = item.split("x:");
    if (
      name[3] === "مشتریان خانگی" ||
      name[3] == "پرونده بچگانه" ||
      name[3] == "پرونده لباس زیر"
    ) {
      itemsHomeLength++;
      return (
        <tr key={index}>
          <td>
            <span className="text-muted fw-bold d-block fs-7">
              {itemsHomeLength}
            </span>
          </td>
          <td>
            <Link to={`/dashboard/crm/customer-file/${name[1]}`}>
              <span className="text-muted fw-bold d-block fs-7">{name[2]}</span>
            </Link>
          </td>
          <td>
            <span className="text-muted fw-bold d-block fs-7">{name[3]}</span>
          </td>
          <td>
            <span className="text-muted fw-bold d-block fs-7">
              {MiladiToShamsi(name[4])}
            </span>
          </td>
        </tr>
      );
    }
  });
  return (
    <InvoicelessCustomersWrapper className="mt-3">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <BreadCrumb
            margin="mt-3"
            num1="واحد CRM"
            num2="گزارشگیری"
            num3="مشتریان بدون فاکتور"
            href1="/dashboard/crm"
            href2="/dashboard/crm/reporting"
          />
          <Tabs defaultActiveKey="home" className="mb-3">
            <Tab eventKey="home" title="مغازه">
              <Table
                headerTitle={headerTitle}
                title={`مشتریان بدون فاکتور  ${itemsStoreLength}`}
                items={itemsStore}
                setSearch={setSearch}
              />
            </Tab>
            <Tab eventKey="profile" title="خانگی">
              <Table
                headerTitle={headerTitle}
                title={`مشتریان بدون فاکتور  ${itemsHomeLength}`}
                items={itemsHome}
                setSearch={setSearch}
              />
            </Tab>
          </Tabs>
        </>
      )}
    </InvoicelessCustomersWrapper>
  );
};
